import { Box } from '@mui/material';
import { LoadingSkeleton, FormTitleBox } from '../../common/components';
import AuditFilters from './components/AuditFilters';
import AuditTable from './components/AuditTable';
import AuditDetailsDialog from './components/AuditDetailsDialog';
import { useAuditLogs } from './hooks/useAuditLogs';
import SearchIcon from '@mui/icons-material/Search';
import { useUsers } from '../../hooks/useUsers';

const AuditLogs = () => {
  const {
    modules,
    modulesLoading,
    filters,
    page,
    perPage,
    total,
    totalPages,
    actions,
    isLoading,
    isFetching,
    handleFilterChange,
    handleResetFilters,
    handleSearch,
    handlePageChange,
    handlePerPageChange,
    selectedAction,
    handleSelectAction,
    handleCloseAction,
  } = useAuditLogs();
  const { data: users = [], isLoading: usersLoading } = useUsers();

  if (modulesLoading && isLoading) {
    return <LoadingSkeleton />;
  }

  return (
    <Box>
      <FormTitleBox
        title="Auditoría | Acciones históricas"
        showButton
        buttonText={'Buscar'}
        onButtonClick={handleSearch}
        isLoading={isFetching}
        buttonIcon={SearchIcon}
      />

      <AuditFilters
        modules={modules}
        filters={filters}
        onFilterChange={handleFilterChange}
        onReset={handleResetFilters}
        users={users}
        usersLoading={usersLoading}
      />

      <AuditTable
        actions={actions}
        isLoading={isLoading}
        page={page}
        totalPages={totalPages}
        totalCount={total}
        onPageChange={handlePageChange}
        rowsPerPage={perPage}
        onRowsPerPageChange={handlePerPageChange}
        onSelectAction={handleSelectAction}
      />

      <AuditDetailsDialog
        open={Boolean(selectedAction)}
        onClose={handleCloseAction}
        action={selectedAction}
      />
    </Box>
  );
};

export default AuditLogs;
